import { Action as ImportedAction } from './types';
import { State as ImportedState } from './reducer';
import { listenForDiscard } from './discardChangesSaga';
import { listenForSave } from './saveChangesSaga';
import { whitelistSaga } from './whitelistSaga';

export type Action = ImportedAction;
export type State = ImportedState;

export { Actions } from './actions';
export { Types } from './types';
export { reducer } from './reducer';
export * from './selectors';

export const Sagas = [listenForDiscard, whitelistSaga, listenForSave];
